export const isSetValueAutomationEvent = (automationEvent) => {
    return automationEvent.type === 'setValue';
};
//# sourceMappingURL=set-value-automation-event.js.map